import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError.js';
import { Toast } from '../../../../../../Notification/index.js';

const createTourIndicator = async ({ state, userId, addTourIndicator, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { codeId, indicatorId, tourId, billable, jobElementId, cost, tourStartTime } = itemDetails;
  let parameters = {
    codeId,
    indicatorId,
    tourId,
    updatingUserId: userId,
    billable: billable || false,
    jobElementId: jobElementId || 0,
    cost: cost || 0
  };
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Indicator Added', description: `For ${resource.name} on ${day}`};
  try {
    await addTourIndicator(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTourPayTransaction',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Indicator Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default createTourIndicator;
